/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana"
            ],
            "plural": [
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana"
            ],
            "singular": [
                  "dan",
                  "dana",
                  "danu",
                  "dan",
                  "o danu",
                  "danom",
                  "dane"
            ]
      },
      "hour": {
            "few": [
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata"
            ],
            "plural": [
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati"
            ],
            "singular": [
                  "sat",
                  "sata",
                  "satu",
                  "sat",
                  "satu",
                  "satom",
                  "sat"
            ]
      },
      "minute": {
            "few": [
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute"
            ],
            "plural": [
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta"
            ],
            "singular": [
                  "minuta",
                  "minute",
                  "minuti",
                  "minutu",
                  "minuti",
                  "minutom",
                  "minuto"
            ]
      },
      "month": {
            "few": [
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca"
            ],
            "plural": [
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci"
            ],
            "singular": [
                  "mjesec",
                  "mjeseca",
                  "mjesecu",
                  "mjesec",
                  "mjesecu",
                  "mjesecom",
                  "mjeseče"
            ]
      },
      "second": {
            "few": [
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde"
            ],
            "plural": [
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi"
            ],
            "singular": [
                  "sekunda",
                  "sekunde",
                  "sekundi",
                  "sekundu",
                  "sekundi",
                  "sekundom",
                  "sekundom"
            ]
      },
      "year": {
            "few": [
                  "godine",
                  "godine",
                  "godine",
                  "godine",
                  "godinama",
                  "godinama",
                  "godine"
            ],
            "plural": [
                  "godina",
                  "godina",
                  "godina",
                  "godina",
                  "godine",
                  "godine",
                  "godina"
            ],
            "singular": [
                  "godina",
                  "godine",
                  "godini",
                  "godinu",
                  "godini",
                  "godinom",
                  "godino"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
